// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setPerformanceDashboardCaseManagers,
  setPerformanceDashboardGeneralInfo,
  resetPerformanceDashboardData
} from 'src/store/modules/dashboard/performanceDashboard'

const initialState = {
  performanceDashboardCaseManagers: [],
  performanceDashboardGeneralInfo: {}
}

export default handleActions(
  {
    [setPerformanceDashboardCaseManagers](
      state,
      { payload: performanceDashboardCaseManagers }
    ) {
      return {
        ...state,
        performanceDashboardCaseManagers
      }
    },

    [setPerformanceDashboardGeneralInfo](
      state,
      { payload: performanceDashboardGeneralInfo }
    ) {
      return {
        ...state,
        performanceDashboardGeneralInfo
      }
    },

    [resetPerformanceDashboardData]() {
      return { ...initialState }
    }
  },
  initialState
)
